// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"8f55a406","470":"b06fa063","1035":"ccefc78b","2021":"ccefc78b","2931":"8f55a406","5714":"8f55a406","6699":"8f55a406"}[chunkId] + ".chunk.css";
};